import React from 'react';

import { translate } from 'components/translate';
import PropTypes from 'prop-types';

import NotificationItemContent from './NotificationItemContent';
import NotificationItemStandard from './NotificationItemStandard';

@translate()
export default class NotificationItemAreaCommunity extends NotificationItemStandard {
  static propTypes = {
    createDate: PropTypes.number,
    updatedDate: PropTypes.number,
    amount: PropTypes.number,
    t: PropTypes.func
  };

  get renderImg() {
    return <span className="icon icon-community" />;
  }

  get renderContent() {
    const { amount = 1, createDate, updatedDate, t } = this.props;

    const text = t('notification.area_community', {
      amountToPluralize: amount,
      data: { amount }
    });

    return (
      <NotificationItemContent text={text} date={updatedDate || createDate} />
    );
  }
}
